import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Wallet payment handler.
 * Handle wallet payments (e.g., MercadoPago wallet) by dispatching the
 * wallet payment action.
 */
registerHandler('wallet', {
  execute: async ({ onWalletPaymentAttempt }) => {
    onWalletPaymentAttempt();
  },
});
